// GalleryMarkerBase.js
export class GalleryMarkerBase {
    markerFactory;

    constructor(mapAdapter, markerFactory, points, options = {}) {
        this.mapAdapter = mapAdapter;
        this.markerFactory = markerFactory;

        this.points = points;
        this.options = {
            color: '#000000',
            offsetX: 0,
            offsetY: 0,
            zIndex: 1,
            ...options
        };
        let adjustedPoints = [];
        for (let point of this.points) {
            adjustedPoints.push(this.applyOffsetToLatLng(point));
        }
        this.points = adjustedPoints;
        this.drawnElements = []; // z.B. circle, poly, marker usw.
    }

    applyOffsetToLatLng(point) {
        return {
            lat: point.lat + this.options.offsetY,
            lng: point.lng + this.options.offsetX
        };
    }

    createOriginMarker(latLng) {
        if (!this.points?.length) {
            return;
        }

        const div = document.createElement('div');
        div.className = 'galleryMarkerOrigin';
        div.style.width = '4px';
        div.style.height = '4px';
        div.style.borderRadius = '50%';
        div.style.border = `4px solid ${this.options.color}`;
        div.style.color = this.options.color;
        div.style.boxShadow = '0 0 3px rgba(0,0,0,0.5)';
        div.style.position = 'relative';
        div.style.transform = 'translate(0%, 50%)';


        return this.markerFactory.createAdvancedMarker({
            map: this.mapAdapter.getMapInstance(),
            position: latLng,
            content: div,
            gmpClickable: false
        });
    }

    clear() {
        for (const el of this.drawnElements) {
            if (el.setMap) el.setMap(null);
        }
        this.drawnElements = [];
    }

    draw(map) {
        throw new Error("draw() muss in Subklasse implementiert werden");
    }

    getBounds() {
        const bounds = this.mapAdapter.createLatLngBounds();
        this.points.forEach(point => {
            const latLng = this.mapAdapter.createLatLng(point.lat, point.lng);
            bounds.extend(latLng);
        });
        return bounds;
    }
}
